export default __webpack_public_path__ + "static/media/b5.48f299ae.jpg";